import { Component, OnInit, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { PageTitle } from '../../models/models';
import { AuthGuard } from '../../services/auth/auth.guard';
import { HeaderService } from '../../services/header.service';
import { environment } from "../../../environments/environment";
import { DOCUMENT } from '@angular/common';
import { Router } from "@angular/router";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  subscription: Subscription;
  pageTitle: PageTitle;
  userName: string;
  isUserHasAssociations?: boolean;

  constructor(
    private headerService: HeaderService,
    private authGuard: AuthGuard,
    @Inject(DOCUMENT) private document: Document,
    private router: Router) { }

  ngOnInit() {
    this.subscription = this.headerService.pageTitle$.subscribe(pageTitle => this.pageTitle = pageTitle);
    this.authGuard.authLoggedIn$.subscribe(user => {
      this.userName = user.fullName;
      this.isUserHasAssociations = user.isUserHasAssociations;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public changePasswordClick(event: Event): void {
    event.preventDefault();
    this.document.location.href = './authorize/change_password';
  }

  public logoutClick(event: Event): void {
    event.preventDefault();
    this.document.location.href = './authorize/logout';
  }

  
}
